import { useEffect } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import { store } from './store'
import 'react-toastify/dist/ReactToastify.css'
import { loadUser } from './actions/userActions'
import ProtectedRoute from './routes/protectedRoutes'
import AdminRoute from './routes/AdminRoute'
import { useDispatch } from 'react-redux'
import Login from './pages/Login'
import Home from './pages/Home'
import Message from './pages/Message'
import Notes from './pages/Notes'
import Employees from './pages/Employees'
import Users from './pages/Users'
import Banners from './pages/Banners'
import AddPrice from './pages/AllIndiaTax/AddPrice'
import AllIndiaPermitPrice from './pages/AllIndiaPermit/Price'
import CreateState from './pages/BorderTax/CreateState'
import RoadTaxCreateState from './pages/RoadTax/CreateState'
import RoadTaxCreateTaxMode from './pages/RoadTax/CreateTaxMode'
import BorderTaxCreateTaxMode from './pages/BorderTax/CreateTaxMode'
import RoadTaxCreatePrice from './pages/RoadTax/CreatePrice'
import BorderTaxCreatePrice from './pages/BorderTax/CreatePrice'
import NewOrders from './pages/Orders/NewOrders'
import CompletedOrders from './pages/Orders/CompletedOrders'
import RefundedOrders from './pages/Orders/RefundedOrders'
import SearchOrders from './pages/Orders/SearchOrders'
import NotFound from './pages/NotFound'

const App = () => {
  const dispatch = useDispatch()
  useEffect(() => {
    store.dispatch(loadUser())
  }, [dispatch])

  return (
    <BrowserRouter>
      <ToastContainer 
        style={{
          top: '20px',
          // left: '25px',
          width: 'auto',
          maxWidth: '90%'
        }}
      />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<AdminRoute><Home /></AdminRoute>} />
          <Route path="/message" element={<AdminRoute><Message /></AdminRoute>} />
          <Route path="/notes" element={<AdminRoute><Notes /></AdminRoute>} />
          <Route path="/employees" element={<AdminRoute><Employees /></AdminRoute>} />
          <Route path="/users" element={<AdminRoute><Users /></AdminRoute>} />
          <Route path="/banners" element={<AdminRoute><Banners /></AdminRoute>} />
          <Route path="/all-india-tax/price" element={<AdminRoute><AddPrice /></AdminRoute>} />
          <Route path="/all-india-permit/price" element={<AdminRoute><AllIndiaPermitPrice /></AdminRoute>} />
          <Route path="/border-tax/states" element={<AdminRoute><CreateState /></AdminRoute>} />
          <Route path="/road-tax/states" element={<AdminRoute><RoadTaxCreateState /></AdminRoute>} />
          <Route path="/road-tax/tax-modes" element={<AdminRoute><RoadTaxCreateTaxMode /></AdminRoute>} />
          <Route path="/border-tax/tax-modes" element={<AdminRoute><BorderTaxCreateTaxMode /></AdminRoute>} />
          <Route path="/road-tax/prices" element={<AdminRoute><RoadTaxCreatePrice /></AdminRoute>} />
          <Route path="/border-tax/prices" element={<AdminRoute><BorderTaxCreatePrice /></AdminRoute>} />
          <Route path="/orders/new" element={<NewOrders />} />
          <Route path="/orders/completed" element={<CompletedOrders />} />
          <Route path="/orders/refunded" element={<RefundedOrders />} />
          <Route path="/orders/search" element={<SearchOrders />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default App
